// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dfc77ab8","603":"0f8e1efd"}[chunkId] + ".chunk.js";
};